import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Checkbox, Input, Tooltip } from "antd";
import styled from "styled-components";

import CurrencyInput from "../../../CurrencyInput";
import { questionHasError } from "../constants";

const StyledInput = styled(Input)`
  border-color: ${({ error, theme }) => error && theme["@alert"]} !important;
  cursor: default !important;
  width: 65px !important;
  z-index: 1 !important;
`;

const ErrorLabel = styled.p`
  color: ${({ theme }) => theme["@alert"]};
  margin: 4px 0 0 4px;
`;

const Container = styled.div`
  display: flex;
  margin-left: 30%;
  width: 65%;
`;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

function ScreeningSalaryRange({ t, onChange, onError, option }) {
  const [isKnockout, setIsKnockout] = useState(option.knockout);
  const [[min, max], setInternalValue] = useState(
    option.validRange || [undefined, undefined]
  );

  const valid = useMemo(() => {
    return (
      isKnockout &&
      (max === undefined || min === undefined
        ? t("form:emptyFieldValidation")
        : max <= min && t("form:minMaxValidation"))
    );
  }, [isKnockout, max, min, t]);

  useEffect(() => {
    if (valid && !questionHasError(option)) onError(valid);
    if (!valid && questionHasError(option)) onError();
  }, [isKnockout, onError, option, valid]);

  const handleMinChange = useCallback(
    minValue => {
      const { validRange } = option;
      setInternalValue(prevState => [minValue, prevState[1]]);
      onChange({ validRange: [minValue, validRange[1] || undefined] });
    },
    [onChange, option]
  );

  const handleMaxChange = useCallback(
    maxValue => {
      const { validRange } = option;
      setInternalValue(prevState => [prevState[0], maxValue]);
      onChange({ validRange: [validRange[0] || undefined, maxValue] });
    },
    [onChange, option]
  );

  const handleKnockoutChange = useCallback(
    event => {
      const knockout = event.target.checked;
      onChange({
        knockout,
        validRange: knockout ? [min, max] : undefined
      });
      setIsKnockout(knockout);
    },
    [max, min, onChange]
  );
  return (
    <Container>
      {/* TODO move to styled */}
      <Checkbox
        data-test="screening-salary-knockout"
        style={{
          minWidth: 220,
          marginRight: 74,
          padding: "3px 1px"
        }}
        checked={isKnockout}
        onChange={handleKnockoutChange}
      >
        {t("opportunity:screening.salaryKnockout")}
      </Checkbox>
      <InputContainer>
        <Input.Group compact>
          <Tooltip title={t("currency:label")}>
            <StyledInput
              error={questionHasError(option)}
              disabled
              placeholder={t("currency:id")}
            />
          </Tooltip>
          <CurrencyInput
            data-test="screening-salary-min"
            disabled={!isKnockout}
            error={questionHasError(option)}
            placeholder={t("opportunity:screening.shortMin")}
            value={min}
            onChange={handleMinChange}
          />
          <Tooltip title={t("currency:label")}>
            <StyledInput
              error={questionHasError(option)}
              disabled
              placeholder={t("currency:id")}
            />
          </Tooltip>
          <CurrencyInput
            data-test="screening-salary-max"
            disabled={!isKnockout}
            error={questionHasError(option)}
            placeholder={t("opportunity:screening.shortMax")}
            value={max}
            onChange={handleMaxChange}
          />
        </Input.Group>
        {questionHasError(option) && <ErrorLabel>{option.error}</ErrorLabel>}
      </InputContainer>
    </Container>
  );
}

export default ScreeningSalaryRange;
